export const NOT_STARTED = "TASKSTATUS_NOTSTARTED";
export const IN_PROGRESS = "TASKSTATUS_INPROGRESS";
export const COMPLETED = "TASKSTATUS_COMPLETED";
export const CANCELLED = "TASKSTATUS_CANCELLED";
